module.exports = __webpack_public_path__ + "img/diagram-bg.055fb263.svg";